var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 5.49985C14.8436 5.34362 14.6317 5.25586 14.4107 5.25586C14.1897 5.25586 13.9778 5.34362 13.8215 5.49985L9.99985 9.32152L6.17818 5.49985C6.02191 5.34362 5.80998 5.25586 5.58901 5.25586C5.36804 5.25586 5.15612 5.34362 4.99985 5.49985C4.84362 5.65612 4.75586 5.86804 4.75586 6.08901C4.75586 6.30998 4.84362 6.52191 4.99985 6.67818L8.82152 10.4998L4.99985 14.3215C4.84362 14.4778 4.75586 14.6897 4.75586 14.9107C4.75586 15.1317 4.84362 15.3436 4.99985 15.4998C5.15612 15.6561 5.36804 15.7438 5.58901 15.7438C5.80998 15.7438 6.02191 15.6561 6.17818 15.4998L9.99985 11.6782L13.8215 15.4998C13.9778 15.6561 14.1897 15.7438 14.4107 15.7438C14.6317 15.7438 14.8436 15.6561 14.9998 15.4998C15.1561 15.3436 15.2438 15.1317 15.2438 14.9107C15.2438 14.6897 15.1561 14.4778 14.9998 14.3215L11.1782 10.4998L14.9998 6.67818C15.1561 6.52191 15.2438 6.30998 15.2438 6.08901C15.2438 5.86804 15.1561 5.65612 14.9998 5.49985Z",
    fill: "#98A1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.093782949b444094acde4cf9b2b91310.svg";
export { ForwardRef as ReactComponent };